import clsx from 'clsx';
import React from 'react';

import { User } from '../../../../utils/backend-api/currentUser';
import TopicPostAuthor from '../TopicPostAuthor';
import styles from './styles.module.scss';

export default function TopicPostAuthors({ authors }: { authors: User[] }): null | JSX.Element {
  if (!authors.length) {
    return null;
  }

  return (
    <div className="topic-users">
      <div className="reporter-container row">
        <div className="col-xs-12">
          <span className="topic-users-heading">Popular Contributors</span>
        </div>
      </div>
      <div id="authors-avatars" className="row">
        <div className="col-xs-12">
          <div className={clsx(styles.bylineContainer)}>
            <div className={clsx(styles.byline)}>
              <div className={clsx(styles.bylineWrapper)}>
                {authors.map((author) => (
                  <TopicPostAuthor key={author.id} author={author} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
